import { render } from "./InitiativeForm.vue?vue&type=template&id=115c04be&scoped=true"
import script from "./InitiativeForm.vue?vue&type=script&lang=js"
export * from "./InitiativeForm.vue?vue&type=script&lang=js"

import "./InitiativeForm.vue?vue&type=style&index=0&id=115c04be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115c04be"]])

export default __exports__